<template lang="pug">
section.about-us-timeline.module-layout
	template(v-if="formState == FORM_STATES.TIMELINE")
		template(v-if="visibleFilter")
			aside.filter-box
				.filter-box__header(@click="filterBlockVisible = !filterBlockVisible")
					span.filter-box__title Categories
					button.filter-box__btn(:aria-expanded="'' + filterBlockVisible", aria-controls="a11y-filters", :class="{ 'filter-box__btn--active': filterBlockVisible }")
						span.sr-only Choose category
						strong {{ activeFilterCount }} Categories
						span.icon(aria-hidden="true")
				.filter-box__body(v-show="filterBlockVisible && isMobile || !isMobile")
					fieldset#a11y-filters.filter-box__filters(:aria-hidden="'' + (!filterBlockVisible && isMobile)")
						legend.sr-only Kategóriák
						.filter-box__filter-wrapper
							vue-checkbox#award-check(name="timeline-filter", v-model="filters.award") Awards
							vue-checkbox#mileStone-check(type="checkbox", name="timeline-filter", v-model="filters.milestone") Milestones
		.timeline
			.cards
				section.card(v-for="(card, index) in filteredTimelineData", v-html="card.content", :class="card.image_size ? card.image_size : ''")
				vue-button.card__btn(v-if="loadButtonVisible", @click="loadMore") Load more
	template(v-if="formState == FORM_STATES.TECHNICAL_ERROR")
		vue-form-notification Technical error
</template>
<script>
import VueCheckbox from '@ui-common/vue-checkbox';
import VueFormNotification from '@ui-common/vue-form-notification';
import { isMobile } from '@ui-common/sf-js-utils';

const FORM_STATES = {
	TIMELINE: 'TIMELINE',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};
const GTM_TYPES = {
	AWARDS: 'Awards',
	MILESTONES: 'Milestones'
};
const INIT_LOADED_CARDS = 5;

export default {
	mixins: [isMobile],
	components: {
		VueCheckbox,
		VueFormNotification
	},
	data: () => ({
		formState: FORM_STATES.TIMELINE,
		timelineData: null,
		filterBlockVisible: false,
		filters: {
			award: true,
			milestone: true
		},
		loadedCard: INIT_LOADED_CARDS
	}),
	props: {
		visibleFilter: {
			type: Boolean,
			default: true
		}
	},
	created() {
		this.timelineData = window?.timeLine?.timeLineElements;
		if (!this.timelineData) {
			this.formState = FORM_STATES.TECHNICAL_ERROR;
		}
	},
	computed: {
		FORM_STATES: () => FORM_STATES,
		filteredTimelineData() {
			return this.selectedCategories.length
				? this.timelineData.filter((card) => this.selectedCategories.includes(card.type)).slice(0, this.loadedCard)
				: this.timelineData.slice(0, this.loadedCard);
		},
		activeFilterCount() {
			return Object.values(this.filters).reduce((acc, filter) => acc + filter, 0) || this.categoryCount;
		},
		selectedCategories() {
			return Object.keys(this.filters).filter((id) => {
				return this.filters[id];
			});
		},
		categoryCount() {
			return Object.keys(this.filters).length;
		},
		loadButtonVisible() {
			return this.filteredTimelineData.length >= this.loadedCard;
		}
	},
	methods: {
		loadMore() {
			this.loadedCard += INIT_LOADED_CARDS;
		},
		sendGtm(type, newVal) {
			this.$gtm.trackEvent({
				event: 'formElementFilled',
				formElementID: type,
				formID: 'Categories',
				inputValue: newVal
			});
		}
	},
	watch: {
		'filters.award': {
			handler(val) {
				this.sendGtm(GTM_TYPES.AWARDS, val);
			}
		},
		'filters.milestone': {
			handler(val) {
				this.sendGtm(GTM_TYPES.MILESTONES, val);
			}
		}
	}
};
</script>
<style src="./about-us-timeline.scss" lang="scss" scoped></style>
<style lang="scss">
@import '@ui-common/sf-style-utils/lib/helpers/_queries.scss';

.about-us-timeline .sf-checkbox {
	@include media('>=tablet') {
		margin: 0 32px 0 0;
		width: auto;
	}
}
</style>
